import React,{useEffect}from 'react'
import bgimg from '../../assets/images/Frame 1597884419 (2).webp'
import arrowicon from '../../assets/images/green 34.webp'
import twitter from '../../assets/images/green 35.webp'
import facebook from '../../assets/images/green 36.webp'
import insta from '../../assets/images/green 37.webp'
import ellipse from '../../assets/images/Group 9.webp'
import { Link } from 'react-router-dom'
import AOS from "aos";
import "aos/dist/aos.css";
const Homebanner = () => {
  return (
    <div>
      <section className='overflow-hidden  navscroll' id="Home">
        <div className=''>
        <div className='container '>
          <div className='bg_img '>
            <div className='row mobres'>
              <div className='col-lg-12'>
                <div className=' home_banner'>
                  <div className='row'>
                    <div className='col-lg-12'>
                      <div className='headp1' data-aos="fade-right"  data-aos-duration="1000">
                      At Northwood, Our Mission Is Clear. 
                      </div>
                      <h1 className='headborder1' data-aos="fade-left"  data-aos-duration="1000">
                      To Deliver Excellence On </h1>
                      <h1 className='headborder2' data-aos="fade-left"  data-aos-duration="1000">All Levels.</h1>
                      <p className='pt-2' data-aos="fade-right" data-aos-duration="1000">We’re not just moving cargo from one place to another,<br/>
                       We're building bridges of trust and reliability with each shipment.</p>

                    </div>

                  </div>
                  {/* <div className=' icons mb-4'>
                    <i class="fa-brands fa-x-twitter fonticon rounded-circle"></i>
                    <i class="fa-brands fa-facebook-f fonticon rounded-circle"></i>
                    <i class="fa-brands fa-instagram fonticon rounded-circle"></i>
                  </div> */}

                </div>
                <div className='d-flex flex-row justify-content-center gap-3 mt-3'> 
                  <Link to="/?id=Contactus">
                  <button className='getbtn' data-aos="zoom-in"  data-aos-duration="1000">
                    Get In Touch
                  </button>
                  </Link>
                  {/* <i class="fa-solid fa-arrow-right arrow rounded-circle"></i> */}
                 
                </div>
              </div>
            </div>
          </div>

          <div className='text-center'>
          <Link to="/?id=content">
            <img src={ellipse} className="ellipseclick" alt='ellipseclick' />
            </Link>
          </div>


          <div className=' row justify-content-center homepy'id="content">
            <div className='col-lg-7 homecontent' data-aos="fade-left"  data-aos-duration="1000">
              <p>
                Each one of our services - from <span>Vessel Inspection</span> to <span>Freight Forwarding</span> and <span>General Trading</span> - are designed to build and nurture long-term and meaningful relationships with our customers.
              </p>
              <p>
                Building partnerships which stand the test of time is something we at Northwood will always believe in.
              </p>
            </div>
          </div>
        </div>
        <div className='home2bg'>
          <div className='row justify-content-center' data-aos="fade-right"  data-aos-duration="1000">
          <div className='col-lg-7 homepara'>
            <div>We understand that in order to be the most trusted and forward-thinking shipping</div>
            <div> partner,every touchpoint has to be measured and tuned.</div>
          </div>
          
          </div>
        </div>
        <div className='container'>
        <div className='row justify-content-center '>
            <div className='col-lg-7 homecontent1 homecontent' >
              <p data-aos="fade-up"  data-aos-duration="1000">
              This <span>Vision</span> is the heartbeat of our Operations.<br/>
              Every decision that happens is infused with this vision. 
              </p>
              <p data-aos="fade-down"  data-aos-duration="1000">
              <span>Shipping is more than Logistics.</span><br/>
              At Northwood, it’s always been about connecting the world, one shipment at a time.
              </p>
            </div>
          </div>
          </div>
          </div>
      </section>
    </div>
  )
}

export default Homebanner
